import MuiGrid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { Typography as RaisinTypography } from '@raisin/components-lib';
export const Container = styled(MuiGrid)(({ theme }) => ({
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(6, 0),
    fontSize: theme.typography.body2.fontSize,
    borderTop: `1px solid ${theme.palette.grey200.main}`,
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: theme.spacing(4),
    },
    [theme.breakpoints.down('sm')]: {
        gap: theme.spacing(6),
        padding: theme.spacing(4, 0),
    },
}));
export const Grid = styled(MuiGrid)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(6),
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
        justifyContent: 'flex-start',
        gap: theme.spacing(4),
        alignItems: 'center',
    },
}));
export const List = styled('ul')(({ theme }) => ({
    display: 'flex',
    padding: 0,
    margin: 0,
    listStyleType: 'none',
    '& li:first-child': {
        paddingLeft: 0,
    },
    '& li:last-child': {
        paddingRight: 0,
    },
    [theme.breakpoints.down('md')]: {
        flexWrap: 'wrap',
        gap: theme.spacing(6),
    },
    [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
        columnGap: theme.spacing(12),
        rowGap: theme.spacing(4),
    },
}));
export const ListItem = styled('li')(({ theme }) => ({
    padding: theme.spacing(0, 3),
    [theme.breakpoints.down('md')]: {
        padding: 0,
    },
}));
export const Link = styled('a')(({ theme }) => ({
    color: theme.palette.grey700.main,
    textDecoration: 'none',
    '&:hover': {
        color: theme.palette.grey700.main,
        textDecoration: 'underline',
    },
    [theme.breakpoints.down('md')]: {
        padding: 0,
    },
}));
export const Copyright = styled(RaisinTypography)(({ theme }) => ({
    color: theme.palette.grey700.main,
    [theme.breakpoints.down('md')]: {
        margin: 0,
    },
}));
export const Typography = styled(RaisinTypography)(({ theme }) => ({
    color: theme.palette.grey700.main,
    [theme.breakpoints.down('md')]: {
        margin: 0,
    },
}));
//# sourceMappingURL=styles.js.map